<app-custom-tabs [tabs]="[
  {
id: 'all',
label: 'All Prices'
  },
  {
id: 'services',
label: 'Services'
  },
  {
    id:'products',
    label: 'Products' } ]
    " [activeTabId]="'all'" (tabClicked)="processTabChanges($event)">

</app-custom-tabs>
<div class="gap py-8"></div>
<mat-card style="width: min-content; max-width: 100%;">
  <mat-card-header>
    <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
      <div class="left">
        <mat-card-title>Prices for Products & Services</mat-card-title>
        <mat-card-subtitle>
          Manage billing charges and pricing for services and procedures.
        </mat-card-subtitle>
      </div>
      <div class="right gap-10 g-just-flex" style="flex: 1 1 auto; justify-content: flex-end;">
        @if (canExport$ | async) {
        <a mat-flat-button extended class="secondary-button small-button" (click)="onExportCharges()">
          <mat-icon>file_download</mat-icon>
          Export
        </a>
        }
        @if (canAdd$ | async) {
        <a mat-flat-button (click)="onAddCharge()">
          <mat-icon>add</mat-icon>
          Add Charge
        </a>
        }
      </div>
    </div>
  </mat-card-header>

  <mat-card-content class="my-12">
    <mat-divider></mat-divider>

    <app-table-header [patientsTableFilterArray]="tableHeaderMappedFilterArray!"
      [patientsFiltersFormControlObject]="tableHeaderFiltersFormControlObject">
    </app-table-header>

    <div class="table-or-empty" style="background-color: var(--mat-sys-surface)">
      @if (tableDataSource.data?.length) {
      <table style="min-width: 630px; width: unset" mat-table matSort [dataSource]="tableDataSource.data"
        class="mat-elevation-z8 demo-table">

        <!-- Title Column -->

        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="title">Product / Service</th>
          <td mat-cell *matCellDef="let charge">
            <!-- {{charge.instance[0].display | json}} -->
            <div class="top pt-8 restrict-length">
              @if(charge.instance?.[0]){
              <!-- {{charge.instance?.[0] | json}} -->
              @if(charge.instance[0].display){
              <span class=" restrict-length">{{
                (charge.instance[0].display) | titlecase | na }}</span>
              } @else {
              <div [appReferenceDisplay]="charge.instance?.[0]?.reference" [instantFetchAndReplace]="true"></div>
              }
              }@else if(charge.code){
              <span>
                {{ (charge.code | codeableConcept2) | titlecase | na }}
              </span>

              }@else {
              N / A
              }
              <!-- <span class="restrict-length">{{ (charge.title) | titlecase | na }}</span> -->
            </div>
            @if (charge.description) {
            <div class="restrict-length subtitle-text-color-2 small-subtitle pb-4">
              <span>{{ charge.description }}</span>
            </div>
            }
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
          <td mat-cell *matCellDef="let charge">
            @if (charge.status) {
            <div [appChips]="charge.status" [fontSize]="'14px'"></div>
            } @else {
            <span class="subtitle-text-color-2">N/A</span>
            }
          </td>
        </ng-container>

        <!-- Code Column - uses codeDisplay additional key -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="code">Code</th>
          <td mat-cell *matCellDef="let charge">
            {{ charge.codeDisplay | titlecase }}
          </td>
        </ng-container>

        <!-- Base Price Column - uses basePriceDisplay additional key -->
        <ng-container matColumnDef="basePrice">
          <th mat-header-cell *matHeaderCellDef>Base Price</th>
          <td mat-cell *matCellDef="let charge">
            <strong>{{ charge.basePriceDisplay }}</strong>
          </td>
        </ng-container>

        <!-- Effective Period Column - uses effectivePeriodDisplay additional key -->
        <ng-container matColumnDef="effectivePeriod">
          <th mat-header-cell *matHeaderCellDef>Effective Period</th>
          <td mat-cell *matCellDef="let charge">
            {{ charge.effectivePeriodDisplay }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let charge">
            <button mat-icon-button [matMenuTriggerFor]="chargeMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #chargeMenu="matMenu">
              <button mat-menu-item (click)="showChargeDetails(charge); $event.stopPropagation()">
                <mat-icon>visibility</mat-icon>
                <span>View Details</span>
              </button>
              <button mat-menu-item (click)="editCharge(charge); $event.stopPropagation()">
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button mat-menu-item (click)="deleteCharge(charge); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" matHeaderRowDefSticky="true"></tr>
        <tr mat-row (click)="showRow(row)" *matRowDef="let row; columns: displayedColumns;" style="cursor: pointer;">
        </tr>
      </table>
      } @else {
      <div class="g-just-flex flex-column align-items-center py-40" style="text-align:center;">
        <app-empty-state [icon]="'payments'" [title]="'No Charges Found'"
          [subtitle]="'No charge item definitions are registered yet.'">
        </app-empty-state>
      </div>
      }
    </div>
  </mat-card-content>
</mat-card>